import React, { useState } from 'react';
import { useNavigateWithinProject } from '../utils/navigation';

interface TabItem {
    displayName: string;
    url: string;
}

const ProjectNavigation: React.FC = () => {
    const tabs: TabItem[] = [
        { displayName: 'Labels', url: '/labels' },
        { displayName: 'Pack Copies', url: '/pack-copies' },
    ];

    const initialTab = tabs.find((tab) => location.pathname.endsWith(tab.url));

    if (!initialTab) return null;

    // Set the default active tab to the first tab in the array
    const [activeTab, setActiveTab] = useState<string>(initialTab.displayName);

    const navigate = useNavigateWithinProject();

    const handleTabChange = (tab: TabItem) => {
        setActiveTab(tab.displayName);
        navigate(tab.url);
    };

    return (
        <div className="project-navigation">
            <div className="tabs">
                {tabs.map((tab) => (
                    <button
                        key={tab.displayName}
                        className={`tab ${activeTab === tab.displayName ? 'active' : ''}`}
                        onClick={() => handleTabChange(tab)}
                    >
                        {tab.displayName}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ProjectNavigation;
